<template>
  <div>
    <div class="sac__font-18 med">
      Plan & Benefits
    </div>
    <div
      class="card"
    >
      <div class="grid-column ai-c jc-s gap-16">
        <div>You are currently on: </div>
        <div v-if="planInfo.name" class="sac-tag f-primary">
          {{ planInfo.name }}
        </div>
        <div v-else class="sac__font-16 med tomato">
          NA
        </div>
      </div>
      <div>
        <div
          v-for="(item, idx) in planInfo.serviceList"
          :key="idx"
          class="grid-column ai-c gap-16 jc-s margin-top-16"
        >
          <img
            src="@shared/assets/img/performance-summary/check-bullet.svg"
            class="img-size-20"
            alt="check"
          />
          <div class="sac__font-16 n60">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'PlanDetail',
  computed: {
    ...mapState({
      providerPlan: (state) => state.customerDetail.providerPlan,
    }),
    planInfo() {
      const {
        name,
        services,
      } = this.providerPlan;

      const serviceList = Array.isArray(services) && services.map((item) => item.service);
      return {
        name,
        serviceList,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  padding: 2rem;
  border-radius: 8px;
  display: grid;
  gap: 0.875rem;
  background-color: $N5;
  margin-top: 1rem;
  min-height: 15rem;
}

</style>
